import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Circuit } from '@app/shared/models/circuit.model';


@Component({
    selector: 'app-circuit-card',
    templateUrl: './circuit-card.component.html',
    styleUrls: ['./circuit-card.component.css'],
    standalone: false
})
export class CircuitCardComponent implements OnInit, OnDestroy {
    @Input() circuit: Circuit;

    constructor() {}

    ngOnInit() {}
    ngOnDestroy() {}


}